import React from 'react'
import { Route, Switch } from 'wouter'

import ContentGenerated from './content_ai'
import AddNewContent from './add_content'

export function ContentAiGroup() {
  return (
    <div>
      <Switch>
        <Route
          path="/content_ai/content_generated"
          component={ContentGenerated}
        />
        <Route path="/content_ai/add_new_content" component={AddNewContent} />
        <Route path="/content_ai/edit_content/:id" component={AddNewContent} />
      </Switch>
    </div>
  )
}
